module.exports = __webpack_public_path__ + "img/logo-moresi-senza-zona-esclusione.8c088f8e.png";